import { Image } from "antd";
import React from "react";
import { SpuImageAttributeData } from "../../../types";

interface ImageAttributeProps {
  attribute: SpuImageAttributeData;
  style: React.CSSProperties;
}

const ImageAttribute = ({ attribute, style }: ImageAttributeProps) => {
  if (!attribute || !attribute.image) {
    return null;
  }

  const src = `${attribute.image}`;

  return (
    <div style={style}>
      <Image src={src} />
    </div>
  );
};

export default ImageAttribute;
